import * as Yup from 'yup'
import {BaseEntity} from '../../../../shared/models/ApiModels'

export interface ISegmentModel extends BaseEntity {
  name: string
}

export const validationSegment = Yup.object().shape({
  name: Yup.string().required('Segment adı zorunludur'),
})

export const initialSegment: ISegmentModel = {
  id: '',
  name: '',
}
